import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import UseCasesTabsDesktopComponent from "segments/desktop/tabs/layouts/use-cases-tabs/use-cases-tabs-desktop-component/use-cases-tabs-desktop-component";
import Title from "segments/desktop/core-components/title/title";
import { APPS_NEW, APPS_RECOMMENDED, APPS_TRENDING } from "../../consts";
import AssetComponent from "/components/core/asset/asset-component";
import { StyledWhatsNewAppsSection } from "./whats-new-apps-section.scss";
const WhatsNewAppsSection = (props)=>{
    const { appsSet } = props;
    const tabs = [
        appsSet[APPS_NEW],
        appsSet[APPS_RECOMMENDED],
        appsSet[APPS_TRENDING]
    ];
    const APPS_TITLE = "Marketplace app highlights";
    const renderApps = (apps)=>{
        var _apps_content;
        return apps === null || apps === void 0 ? void 0 : (_apps_content = apps.content) === null || _apps_content === void 0 ? void 0 : _apps_content.map((app)=>/*#__PURE__*/ _jsx("a", {
                target: "_blank",
                href: app === null || app === void 0 ? void 0 : app.articleLink,
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "app",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "app-image-wrapper",
                            children: /*#__PURE__*/ _jsx(AssetComponent, {
                                image: {
                                    src: app === null || app === void 0 ? void 0 : app.cloudinaryUrl
                                }
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-wrapper",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "app-title",
                                    children: app.title
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "app-description",
                                    children: app.shortText
                                })
                            ]
                        })
                    ]
                })
            }));
    };
    const itemRenderer = (tab)=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "use-case-tab-content",
            children: /*#__PURE__*/ _jsx("div", {
                className: "app-section",
                apps: tab,
                children: renderApps(tab)
            })
        });
    };
    return /*#__PURE__*/ _jsxs(StyledWhatsNewAppsSection, {
        className: "whats-new-apps-section",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "subtle-line",
                style: {
                    marginBottom: "40px"
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "title-wrapper",
                children: /*#__PURE__*/ _jsx(Title, {
                    title: APPS_TITLE
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "tabs-wrapper",
                children: /*#__PURE__*/ _jsx(UseCasesTabsDesktopComponent, {
                    tabs: tabs,
                    replacementItemRenderer: itemRenderer,
                    hideArrows: true,
                    disableDraggable: true
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "subtle-line"
            })
        ]
    });
};
export default WhatsNewAppsSection;
